import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CrmSynchronizationConversationAgentWorkflowComponent } from './crm-synchronization-conversation-agent-workflow/crm-synchronization-conversation-agent-workflow.component';
import { CrmSynchronizationConversationFrequencyComponent } from './crm-synchronization-conversation-frequency/crm-synchronization-conversation-frequency.component';
import { CrmSynchronizationConversationWorkflowMappingsComponent } from './crm-synchronization-conversation-workflow-mappings/crm-synchronization-conversation-workflow-mappings.component';
import { CrmSynchronizationConversationComponent } from './crm-synchronization-conversation.component';

@NgModule({
  declarations: [
    CrmSynchronizationConversationComponent,
    CrmSynchronizationConversationFrequencyComponent,
    CrmSynchronizationConversationAgentWorkflowComponent,
    CrmSynchronizationConversationWorkflowMappingsComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class CrmSynchronizationConversationModule {}
